import api from "@/api";
import store from "@/stores";
import { TypeKeyData } from "@/types";
import { useEffect, useState } from "react";

export const useTypeKeyInfo = (type: string | undefined | null, appTypes: any[]) => {
  const [allTypes, setAllTypes] = useState<any[]>([]);
  const [typeKeyInfo, setTypeInfo] = useState<TypeKeyData>();

  const getAllTypes = async () => {
    const res: any = await api.getAllTypes();
    if (res.code === 200) {
      setAllTypes(res.data);
      store.dispatch({
        type: "setAppTypes",
        payload: res.data,
      });
    }
  };

  useEffect(() => {
    getAllTypes();
  }, []);

  useEffect(() => {
    if (!type || !appTypes.length) return;
    const subType = appTypes.find((item: any) => item.key === type);
    if (!subType) return;
    setTypeInfo(subType);
  }, [type, appTypes]);

  return {
    allTypes,
    typeKeyInfo,
  };
};
